import 'react';
import {Box, Typography} from '@mui/material';

/** Left-rail tab: page code + short title (Ai/Bi index style). */
export default function PageTabLabel({code, title}: {code: string; title: string}) {
    return (
        <Box sx={{textAlign: 'left', py: 0.25, maxWidth: 168}}>
            <Typography variant="body2" fontWeight={700} lineHeight={1.3}>
                {code}
            </Typography>
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                    display: 'block',
                    lineHeight: 1.25,
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                }}
            >
                {title}
            </Typography>
        </Box>
    );
}
